import { render } from "./visa.vue?vue&type=template&id=241a557e&scoped=true"
import script from "./visa.vue?vue&type=script&lang=js"
export * from "./visa.vue?vue&type=script&lang=js"

import "./visa.vue?vue&type=style&index=0&id=241a557e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-241a557e"]])

export default __exports__